import { render, staticRenderFns } from "./instant-search.vue?vue&type=template&id=7df5c712&"
import script from "./instant-search.vue?vue&type=script&lang=js&"
export * from "./instant-search.vue?vue&type=script&lang=js&"
import style0 from "./instant-search.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports